import React from "react";
import Box from "@mui/material/Box";
import SportsTennisIcon from "@mui/icons-material/SportsTennis";
import FitnessCenterIcon from "@mui/icons-material/FitnessCenter";
import GroupsIcon from "@mui/icons-material/Groups";
import EventNoteIcon from "@mui/icons-material/EventNote";

export function formatLongDate(value) {
  if (!value) return "";
  const d = typeof value === "string" ? new Date(value + (value.length === 10 ? "T00:00:00" : "")) : new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return new Intl.DateTimeFormat("en-US", { weekday: "long", year: "numeric", month: "long", day: "numeric" }).format(d);
}

export { formatDuration } from "/imports/libs/format";

function fallbackTypeIcon(type) {
  switch (type) {
    case "court":
      return <SportsTennisIcon />;
    case "lesson":
      return <FitnessCenterIcon />;
    case "class":
      return <GroupsIcon />;
    case "term":
      return <EventNoteIcon />;
    default:
      return <SportsTennisIcon />;
  }
}

export function ItemHeroIcon({ sportIcon, type, size = 56 }) {
  if (sportIcon) {
    return (
      <Box
        sx={{
          width: size,
          height: size,
          WebkitMaskImage: `url(/sports/${sportIcon})`,
          maskImage: `url(/sports/${sportIcon})`,
          WebkitMaskSize: "contain",
          maskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
          maskRepeat: "no-repeat",
          WebkitMaskPosition: "center",
          maskPosition: "center",
          // The sport icon is the accent (secondary), like the category tiles on Home.
          bgcolor: "secondary.main"
        }}
      />
    );
  }
  return fallbackTypeIcon(type);
}

export function itemTitle(item) {
  if (item.serviceName) return item.serviceName;
  if (item.name) return item.name;
  switch (item.type) {
    case "court":
      return "Court Booking";
    case "lesson":
      return "Private Lesson";
    case "class":
      return "Class Session";
    case "term":
      return "Program";
    default:
      return "Booking";
  }
}
